/**
 * Cashier Model
 */

define(function(require, exports, module) {
    'use strict';

    var _ = require('underscore');
    var PortletModel = require('modules/portlet/portlet.model');
    var DepositView = require('portlets/cashier/deposit/deposit.view');
    var WithdrawView = require('portlets/cashier/withdraw/withdraw.view');
    var TransactionHistoryView = require('portlets/cashier/transaction-history/transaction-history.view');
    var PendingView = require('portlets/cashier/pending/pending.view');
    var AddcardView = require('portlets/cashier/addcard/addcard.view');
    var AddcardSc = require('portlets/cashier/addcard-sc/addcard.view');
    var GamingReport = require('portlets/cashier/gaming-report/gaming-report.view');
    var user = require('user');

    module.exports = PortletModel.extend({

        getView: function() {
            var options = this.toJSON();
            var searchParams = new URLSearchParams(location.search);
            var paymentsConfig = user.get('paymentsConfig') || {};
            var tokenProvider = paymentsConfig.tokenProvider;
            var addViaVco = searchParams.get('visaCheckout') && paymentsConfig.enableVisaCheckout;

            switch (this.get('config').cashierType) {
                case 'DEPOSIT':
                    return new DepositView(options);
                case 'WITHDRAW':
                    return new WithdrawView(options);
                case 'TRANSACTION_HISTORY':
                    return new TransactionHistoryView(options);
                case 'DETAILED_TRANSACTION_HISTORY':
                    _.extend(options.config, { isDetailedView: true });
                    return new TransactionHistoryView(options);
                case 'PLAYER_YEARLY_STATISTIC':
                    return new GamingReport(options);
                case 'PENDING_WITHDRAWALS':
                    return new PendingView(options);
                case 'ADD_PAYMENT_METHOD':
                    _.extend(options,
                        {
                            addViaVco: addViaVco,
                            storeCardConfirmationRequired: paymentsConfig.storeCardConfirmationRequired
                        });
                    return tokenProvider === 'safecharge'
                        ? new AddcardSc(options)
                        : new AddcardView(options);
                default:
                    options.cashierType = 'DEPOSIT';
                    return new DepositView(options);
            }
        }
    });
});
